import React, { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const faqItems: FAQItem[] = [
    {
      question: "Comment jouer au Jeu 151 ?",
      answer: "Le Jeu 151 se joue avec 32 cartes traditionnelles. Chaque joueur reçoit des cartes et doit éviter d'être le premier à dépasser 151 points. Les cartes ont des valeurs spécifiques : AS = 11 points, 8 = 32 points, figures (Roi = 4 points, Dame = 3 points, Valet = 2 points), et les autres cartes gardent leur valeur numérique. Les cartes spéciales comme le 8 permettent de changer la couleur, et les AS peuvent bloquer les adversaires."
    },
    {
      question: "Puis-je jouer hors-ligne ?",
      answer: "Oui ! Jeu 151 fonctionne parfaitement en mode hors-ligne. Vous pouvez jouer contre l'ordinateur sans connexion internet. Toutes les fonctionnalités principales sont disponibles hors-ligne, et vos scores seront synchronisés lorsque vous vous reconnectez."
    },
    {
      question: "Est-ce que le jeu est gratuit ?",
      answer: "Oui, Jeu 151 est entièrement gratuit ! Aucun achat in-app n'est requis pour profiter de toutes les fonctionnalités du jeu. Nous croyons que le plaisir de jouer doit être accessible à tous."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="section-padding bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Questions fréquentes
          </h2>
          <p className="text-xl text-gray-600">
            Tout ce que vous devez savoir sur Jeu 151
          </p>
        </div>

        {/* FAQ Items */}
        <div className="space-y-4">
          {faqItems.map((item, index) => (
            <div key={index} className="border border-gray-200 rounded-xl overflow-hidden">
              <button
                className="w-full px-6 py-4 text-left bg-gray-50 hover:bg-gray-100 transition-colors duration-200 flex justify-between items-center"
                onClick={() => toggleFAQ(index)}
              >
                <span className="font-semibold text-gray-900">{item.question}</span>
                <svg
                  className={`w-5 h-5 text-gray-500 transition-transform duration-200 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              
              {openIndex === index && (
                <div className="px-6 py-4 bg-white border-t border-gray-200">
                  <p className="text-gray-600 leading-relaxed">
                    {item.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Additional Help */}
        <div className="mt-12 bg-gradient-to-r from-primary-50 to-primary-100 rounded-2xl p-8 text-center">
          <div className="text-4xl mb-4">💬</div>
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Besoin d'aide ?
          </h3>
          <p className="text-gray-700 mb-6">
            Notre équipe est là pour vous aider avec toutes vos questions
          </p>
          <a
            href="mailto:contact@djammadev.com"
            className="btn-primary inline-flex items-center"
          >
            <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
            </svg>
            Nous contacter
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ; 